var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "draggable-items-scroll-wrapper ignore-force-horizontal-scroll",
      on: { wheel: _vm.handleWheel },
    },
    [
      _c("draggable-virtual-list", {
        ref: "virtualList",
        staticClass: "draggable-items card px-1 mb-0",
        class: { "sortable-empty": _vm.sortableEmpty },
        attrs: {
          group: "status-column",
          "fallback-class": "drag-item-dragging",
          "force-fallback": "true",
          "fallback-on-body": "true",
          size: 52,
          "estimated-size": 52,
          keeps: 50,
          "data-key": "id",
          "data-sources": _vm.profileSources,
          "data-component": _vm.VirtualScrollerItem,
        },
        on: { start: _vm.handleDraggableStart, end: _vm.handleDraggableEnd },
        model: {
          value: _vm.profileSources,
          callback: function ($$v) {
            _vm.profileSources = $$v
          },
          expression: "profileSources",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }